import { useEffect, useState } from "react";
import "../App.scss";

const FACTS = [
  "I love mint-chocolate 🍫🌿",
  "While my hand is right-handed, my foot is left-handed 🦶",
  "ABC conquerer 🔤",
  "Half Marathon conquerer 🏃",
  "Once weighed 100kg ⚖️",
  "Finalist Intel ISEF 🔬",
  "Sponsored by Vespa, driving & blogging bird spots from BKK → Chiang Mai 🛵",
  "High-school Student Honorable Award 🏅",
  "Visited many countries 🌍",
];

export const FunFactPage = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(Math.floor(Math.random() * FACTS.length));
  }, []);

  const next = () => setIndex((i) => (i + 1) % FACTS.length);

  return (
    <div id="wrapper" className="center fade-in">
      <h1 style={{ color: "#556b2f", marginBottom: "1rem" }}>Fun Fact</h1>
      <p
        style={{
          fontSize: "1.25rem",
          maxWidth: 400,
          lineHeight: 1.6,
          marginBottom: "2rem",
        }}
      >
        {FACTS[index]}
      </p>
      <button
        onClick={next}
        style={{
          background: "none",
          border: "1px solid #556b2f",
          color: "#556b2f",
          padding: "0.5rem 1.5rem",
          borderRadius: 4,
          cursor: "pointer",
          fontSize: "0.9rem",
        }}
      >
        Another one →
      </button>
    </div>
  );
};
